<template>
  <v-main>
    <v-container fluid>
      <v-row class="ma-0">
        <!-- Creamos las migas de pan automaticamente -->
        <v-spacer />
        <!-- Tutoriales de youtube -->
        <Tutoriales />
      </v-row>
      <div class="container_info_azul">
        <v-row class="ma-0 mb-0" align="center">
          <v-col>
            <p>{{ $t("En esta sección puedes configurar descuentos automáticos para ventas en un periodo determinado") }}</p>
          </v-col>
        </v-row>
      </div>
      <!-- Generamos el AppBar con las distintas acciones -->
      <v-app-bar color="primary" dense dark style="border-radius: 5px">
        <!-- Crear una nueva newsletter -->
        <v-btn text @click="open_dialog_descuento()">
          <v-icon>mdi-file-outline</v-icon>
          <span class="appbar_button">{{ $t('Nuevo') }}</span>
        </v-btn>
      </v-app-bar>
      <!-- Filtro de busqueda -->
      <v-expansion-panels focusable class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header class="titulo_buscador">
            <span>
              <v-icon large>mdi-magnify</v-icon>
              {{ $t("Buscar") }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-0">
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                    v-model="selected_filters.descripcion__icontains"
                    :label="$t('Título')"
                    dense
                    outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <DatePickerRange
                    v-model="selected_filters.created"
                    :title="$t('Fecha de creación')"
                    dense
                    outlined
                    :hide_details="true"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <CustomSelect
                    v-model="selected_filters.active"
                    :items="data_filters.booleans"
                    :label="$t('Activo')"
                />
              </v-col>
              <v-col class="pt-3 pb-0 text-end">
                <v-btn @click="get_descuentos" fab small right class="primary">
                  <v-icon small>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <TablaDescuentosPorPeriodo
          ref="tabla_descuentos"
          :selected_filters="selected_filters"
          @on_click_edit="open_dialog_descuento"
          @on_save="on_save_descuento"
      />

      <FormDescuentoPorPeriodo
          v-if="dialog_descuento"
          v-model="dialog_descuento"
          :item="current_descuento"
          @on_save="on_save_descuento"
      />

    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'DescuentosPorPeriodo',
  data: () => ({
    // Dialogs
    dialog_descuento: false,
    current_descuento: null,

    // Los filtros seleccionados
    selected_filters: {
      descripcion__icontains: "",
      created: [],
      active: [1]
    },
    data_filters: {
      booleans: []
    }
  }),

  methods: {

    open_dialog_descuento(descuento = null) {
      this.current_descuento = descuento
      this.dialog_descuento = true
    },

    async get_descuentos(){
      // Preparamos los filtros que enviamos a la api
      if(this.selected_filters['created'].length > 0){
        this.selected_filters['created__date__gte'] = this.selected_filters['created'][0]
      }
      if(this.selected_filters['created'].length > 1){
        this.selected_filters['created__date__lte'] = this.selected_filters['created'][1]
      }

      // Los filtros boolean solo se envían si hay marcada una única opción.
      this.selected_filters['is_active'] = ""
      if(this.selected_filters['active'].length === 1){
        this.selected_filters['is_active'] = this.selected_filters['active'][0]
      }

      await this.$refs.tabla_descuentos.get_descuentos()
    },

    async on_save_descuento(){
      this.dialog_descuento = false
      await this.get_descuentos()
    }

  },

  mounted() {
    // Asignamos las fechas del filtro
    this.selected_filters.created.push(this.$moment().add(-3, 'months').format('yyyy-MM-DD'))
    this.selected_filters['created__date__gte'] = this.selected_filters['created'][0]
    this.selected_filters.created.push(this.$moment().format('yyyy-MM-DD'))
    this.selected_filters['created__date__lte'] = this.selected_filters['created'][1]

    this.data_filters.booleans = [
      { text: this.$t("Sí"), value: 1 },
      { text: this.$t("No"), value: 0 }
    ]
  },

  components: {
    TablaDescuentosPorPeriodo: () => import('@/views/Marketing/components/TablaDescuentosPorPeriodo'),
    FormDescuentoPorPeriodo: () => import('@/views/Marketing/components/FormDescuentoPorPeriodo')
  }

}
</script>
